/**
 * Constants for game module names
 */
export class GameModules {

    /**
     * 'Root' game module
     */
    static get Root(): string {
        return 'Root';
    }

    /**
     * 'base' game module
     */
    static get Base(): string {
        return 'base';
    }

    /**
     * 'gamble' game module
     */
    static get Gamble(): string {
        return 'gamble';
    }

    /**
     * 'freespins' game module
     */
    static get Freespins(): string {
        return 'freespins';
    }

    /**
     * 'pick' game module
     */
    static get Pick(): string {
        return 'pick';
    }

    /**
     * 'roulette' game module
     */
    static get Roulette(): string {
        return 'roulette';
    }

    /**
     * 'bonus' game module
     */
    static get BonusRespins(): string {
        return 'bonusrespins';
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/GameModules.ts
 **/